import type { IssueId } from '@atlassian/jira-shared-types';
import { BEFORE, INSIDE } from '@atlassian/jira-software-roadmap-timeline-table';
import type { CreateItemAnchor } from '@atlassian/jira-software-roadmap-timeline-table/src/types';
import { TIMELINE_ROOT_DEPTH, TIMELINE_SUBTASK_HIERARCHY_LEVEL } from '../constants';

/**
 * Determines if the level is a sub-task level.
 * @param {number} level - The level of the item.
 * @returns {boolean} - True if the level is a sub-task level.
 */
export const isSubTaskLevel = (level: number): boolean =>
	level === TIMELINE_SUBTASK_HIERARCHY_LEVEL;

/**
 * Determines if the depth is the root level.
 * @param {number} depth - The depth of the item.
 * @returns {boolean} - True if the depth is the root level.
 */
export const isRootDepth = (depth: number): boolean => depth === TIMELINE_ROOT_DEPTH;

/** Determines if the create item is before the item.
 * @param {CreateItemAnchor} createItemAnchor - The create item anchor.
 * @param {IssueId} id - The id of the issue item.
 */
export const isCreateBeforeItem = (createItemAnchor: CreateItemAnchor, id: IssueId) =>
	createItemAnchor && createItemAnchor.position === BEFORE && createItemAnchor.beforeId === id;

/** Determines if the create item is inside the item.
 * @param {CreateItemAnchor} createItemAnchor - The create item anchor.
 * @param {IssueId} id - The id of the issue item.
 */
export const isCreateInsideItem = (createItemAnchor: CreateItemAnchor, id: IssueId) =>
	createItemAnchor && createItemAnchor.position === INSIDE && createItemAnchor.parentId === id;
